import { render, staticRenderFns } from "./PhoneCall.vue?vue&type=template&id=7616403b&"
import script from "./PhoneCall.vue?vue&type=script&lang=ts&"
export * from "./PhoneCall.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneCall.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
